import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslation from '@hooks/i18n/useTranslation.tsx';
import { CompanyProfile } from '@app/pages/customer/CompanyProfile/CompanyProfile.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';

const PageCompanyProfile = () => {
  const { tr } = useTranslation();

  return (
    <ResponsiveLayout title={tr(`company-profile.companyProfile`, `Profil společnosti`)} oneOfPermission={[PermissionTypesEnum.PERMISSION_SETTINGS_COMPANY_PROFILE]}>
      <CompanyProfile />
    </ResponsiveLayout>
  );
};
export default withAuthenticationRequired(PageCompanyProfile);
